import React, { useState, useEffect } from 'react';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { useCountry } from '../contexts/CountryContext';

const DateTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [showLocalTime, setShowLocalTime] = useState(false);
  const { selectedCountry } = useCountry();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(timer);
  }, []);

  const formatDateTime = (date, timezone = null) => {
    const formattedDate = date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      timeZone: timezone || undefined
    });

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: timezone || undefined
    });

    return `${formattedDate} | ${formattedTime}`;
  };

  const displayTime = showLocalTime 
    ? formatDateTime(currentTime) // Local time
    : formatDateTime(currentTime, selectedCountry.timezone); // Selected country time

  const toggleTimezone = () => {
    setShowLocalTime(!showLocalTime);
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-base text-themeGray">
        {displayTime}
      </span>
      <button
        onClick={toggleTimezone}
        className={`p-1 rounded-md transition-colors ${
          showLocalTime 
            ? 'bg-themeOrange text-white' 
            : 'text-themeGray hover:bg-gray-100'
        }`}
        title={showLocalTime ? `Switch to ${selectedCountry.name} time` : 'Switch to local time'}
      >
        <GlobeAltIcon className="h-4 w-4" />
      </button>
      {showLocalTime && (
        <span className="text-xs text-themeOrange font-medium">LOCAL</span>
      )}
      {!showLocalTime && selectedCountry.code !== 'local' && (
        <span className="text-xs text-themeOrange font-medium">
          {selectedCountry.code.toUpperCase()}
        </span>
      )}
    </div>
  );
};

export default DateTime;